module.exports = __webpack_public_path__ + "static/media/author.8e02f190.jpg";